/* This file is autogenerated, see readme.md for instructions */
import TextBoldSvgIcon from '@bloomreach/banana-theme/icons/text-bold.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TextBoldIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TextBoldSvgIcon />
    </Icon>
  );
});

TextBoldIcon.displayName = 'TextBoldIcon';

export default TextBoldIcon;
